import { render, staticRenderFns } from "./CourseQuiz.vue?vue&type=template&id=31e7a41c&"
import script from "./CourseQuiz.vue?vue&type=script&lang=js&"
export * from "./CourseQuiz.vue?vue&type=script&lang=js&"
import style0 from "./CourseQuiz.vue?vue&type=style&index=0&id=31e7a41c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoursesCourseQuizCustom: require('/opt/build/repo/components/Courses/CourseQuizCustom.vue').default})
